var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!!_vm.breadcrumbs)?_c('div',[_c('v-breadcrumbs',{staticClass:"white--text",attrs:{"items":_vm.breadcrumbs},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
return [_c('v-breadcrumbs-item',{attrs:{"href":item.href,"disabled":item.disabled}},[_vm._v(" "+_vm._s(_vm.$t(item.text))+" ")])]}}],null,false,3904202411)}),_c('v-divider')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }